import { render, staticRenderFns } from "./Mocktests.vue?vue&type=template&id=6e934a54&"
import script from "./Mocktests.vue?vue&type=script&lang=js&"
export * from "./Mocktests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports